import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

const WORDS = ["Painless Root Canals","Clear Aligners","Smile Design","Whitening","Paediatric Care","Implants","Laser Gum Therapy","Crowns & Bridges","Full-Mouth Rehab"];

export default function Marquee() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const x = useTransform(scrollYProgress, [0, 1], [0, -180]);

  return (
    <section ref={ref} className="py-4 md:py-6 bg-[hsl(var(--primary))] text-white overflow-hidden" data-testid="marquee">
      <motion.div className="marquee-track font-display text-2xl md:text-5xl leading-none uppercase tracking-tight" style={{ x }}>
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex items-center gap-10 pr-10">
            {WORDS.map((w, j) => (
              <span key={j} className="flex items-center gap-10">
                <span>{w}</span>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="text-white/70"><path d="M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" fill="currentColor"/></svg>
              </span>
            ))}
          </div>
        ))}
      </motion.div>
    </section>
  );
}
